export default function useReorderChoices(){

    const letter = rank => "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('')[rank - 1] || '';
    

    return (choices) => {

        const sortKey = s => {
            let rankStr = "00000000" + Math.round(s.rank * 10);
            return s.question.id + rankStr.substring(rankStr.length - 6);
        }

        let r = 0; let questionID = '';
        
        let newChoices = [...choices]
            .sort((a,b) => sortKey(a) > sortKey(b) ? 1 : -1)
            .map(s => {
                if(s.question.id !== questionID){
                    r = 0;
                    questionID = s.question.id;
                }
                r++;
                return {...s, rank: r, letter: letter(r)}
            })

        return newChoices;
    }
}